import React from 'react';
import InterestsSection from './InterestsSection';
import TrendingInterests from './TrendingInterests';
import LatestIssues from './LatestIssues';
import ModuleGrid from './ModuleGrid';
import SubtopicModal from './SubtopicModal';
import QuizModal from './QuizModal';
import NoInterestModal from './NoInterestModal';
import ModuleInfoModal from './ModuleInfoModal'; 

const ModuleSelection = ({
  userId,
  userInterests,
  userInterestInput, setUserInterestInput,
  interestErrorMessage,
  topUserInterests,
  latestPassageSubtopics,
  onSubmitInterest,
  onRemoveInterest,
  accessibleModules,
  completedModules,
  passageCounts,
  onModuleSelect,
  showSubtopicModal,
  isLoadingSubtopics,
  subtopics,
  randomUserInterest,
  onSubtopicSelection,
  onCloseSubtopicModal,
  showNoInterestMessage,
  setShowNoInterestMessage,
  errorMessage
}) => {
  console.log('I am in ModuleSelection ', accessibleModules)
  // Add early return if data isn't loaded yet
  if (!accessibleModules || !completedModules) {
    return <div>Loading modules...</div>; // or a proper loading spinner
  }
  
  return (
    <div className="module-selection">
      <div className="interests-and-trending-container">
        {topUserInterests.length > 0 && (
          <TrendingInterests topUserInterests={topUserInterests} />
        )}

        <InterestsSection
          userInterests={userInterests}
          userInterestInput={userInterestInput}
          setUserInterestInput={setUserInterestInput}
          interestErrorMessage={interestErrorMessage}
          onSubmitInterest={onSubmitInterest}
          onRemoveInterest={onRemoveInterest}
        />

        {latestPassageSubtopics.length > 0 && (
          <LatestIssues latestPassageSubtopics={latestPassageSubtopics} />
        )}
      </div>

      <h2 style={{ color: "#405159" }}>
        {accessibleModules.length > 1
          ? "Select a module to practice argument evaluation"
          : "Watch the video and complete the quiz to unlock the modules"}
      </h2>

      <ModuleGrid
        userId={userId}
        completedModules={completedModules}
        accessibleModules={accessibleModules}
        passageCounts={passageCounts}
        onModuleSelect={onModuleSelect}
      />

      {errorMessage && <div className="error-message">{errorMessage}</div>}

      {showNoInterestMessage && (
        <NoInterestModal onClose={() => setShowNoInterestMessage(false)} />
      )}

      {showSubtopicModal && (
        <SubtopicModal
          isLoading={isLoadingSubtopics}
          subtopics={subtopics}
          randomUserInterest={randomUserInterest}
          onSubtopicSelection={onSubtopicSelection}
          onClose={onCloseSubtopicModal}
        />
      )}

    </div>
  );
};

export default ModuleSelection;
